import lottie from "lottie-web";

export default (animationData) => {
  const animateClass = ".js-ready-animate";
  let animateWasPlayedFlag = false;

  const dataAnimation = () => {
    let params = {
      container: document.getElementById("animatedSignature"),
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: animationData
    };

    let anim;
    anim = lottie.loadAnimation(params);
  };

  const inView = function(element) {
    const win = $(window);
    const obj = element;
    const scrollPosition = win.scrollTop();
    const visibleArea = win.scrollTop() + win.height();
    const objEndPos = obj.offset().top;

    return visibleArea >= objEndPos && scrollPosition <= objEndPos;
  };

  const animate = document.querySelector(animateClass);

  if (animate !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag && inView($(animate))) {
        dataAnimation();
        animateWasPlayedFlag = true;
      }
    });
  }
}